<app-admin-boilerplate>
    @if (selectedUser$ | async; as selectedUser){
        <h1>Edit User - {{ selectedUser.firstname | titlecase }} {{ selectedUser.surname | titlecase }}</h1>
        <p class="text-lg italic ms-3 -mt-3">{{ selectedUser.email | lowercase }}</p>
        <div class="flex gap-6 my-2">
            @if (selectedUser.googleId){
                <button class="bg-white border rounded-lg px-6 py-2 flex cursor-default"><img src="assets/google.png" height="32px" width="32px"/><span class="mt-1">Connected with Google</span></button>
            }
            @if (selectedUser.facebookId){
                <button class="bg-blue-700 text-white border rounded-lg  px-6 py-2 cursor-default"><fa-icon class="me-3" [size]="'lg'" [icon]="['fab','facebook']" />Connected with Facebook</button>
            }
        </div>
        <div class="card">
            <h2>Manage User Account</h2>
            @if (isAdmin(selectedUser) || isSuperAdmin(selectedUser)){
                <p class="text-lrpTicketRed font-semibold -mt-4 mb-4">Administrator</p>
            }
            <div class="flex">
                <div class="grid grid-cols-3 w-fit">
                    <div class="col-start-1 col-end-1 font-semibold">
                        Created:
                    </div>
                    <div class="col-start-2 col-end-3">
                        {{ selectedUser.dateCreated| date:'dd-MM-yyyy HH:mm'}}
                    </div>
                    <div class="col-start-1 col-end-1 font-semibold">
                        Last Login:
                    </div>
                    <div class="col-start-2 col-end-3">
                        {{ selectedUser.lastLogin | date:'dd-MM-yyyy HH:mm'}}
                    </div>
                    @if ((selectedUser.failedLoginAttempts ?? 0) > 0){
                        <div class="col-start-1 col-end-1 font-semibold">
                            Failed Logins:
                        </div>
                        <div class="col-start-2 col-end-3">
                            {{ selectedUser.failedLoginAttempts}}
                        </div>
                        <div class="col-start-1 col-end-1 font-semibold">
                            Failed Login:
                        </div>
                        <div class="col-start-2 col-end-3">
                            {{ selectedUser.lastLogin | date:'dd-MM-yyyy HH:mm'}}
                        </div>
                    }
                </div>
                <div class="flex gap-6">
                    <button class="primaryButton button-small !px-10" [disabled]="isSuperAdmin(selectedUser)" [title]="isSuperAdmin(selectedUser) ? 'Actions are restricted for this user' : 'Reset the password for this account'">
                        Reset Password
                    </button>
                    <button class="admin-button button-small !px-10" title="The user will be notified that you have requested detailed information.">
                        <fa-icon class="me-4" [icon]="['fas','triangle-exclamation']"/>Request Personal Information
                    </button>
                    @if (canAccessAdminFunctions()){
                        <button class="admin-button button-small !px-10" title="Lock the requested user account" [disabled]="isSuperAdmin(selectedUser)" [title]="isSuperAdmin(selectedUser) ? 'Actions are restricted for this user' : 'Reset the password for this account'">
                            <fa-icon class="me-4" [icon]="['fas','lock']"/>Lock User Account
                        </button>
                    }
                </div>
            </div>
        </div>
        <table class="w-full !mt-10">
            <thead>
                <th class="text-start min-w-10">Event</th>
                <th class="text-start">Type</th>
                <th class="text-start">Paid</th>
                <th class="text-start">Payment Date</th>
            </thead>
            <tbody>
                @for (booking of selectedUser.eventBookings; track booking){
                    <tr [routerLink]="['/admin/events',booking.event.eventLink,'booking',booking.bookingID]">
                        <td>{{ booking.event.name }}</td>
                        <td>{{ booking.bookingType | titlecase }}</td>
                        <td class="flex gap-2">
                            @if (booking.paid){
                                <fa-icon class="text-green-500" [icon]="['fas','circle-check']" [title]="(booking.bookingPaid | date:'dd-MM-yyyy HH:mm')!"/>
                            }
                            @else if (booking.payOnGate){
                                <fa-icon [icon]="['fas','door-open']" title="Pay on gate"/>
                            }
                            @else {
                                @if (booking.totalPaid > 0){
                                    <fa-icon class="text-amber-500" [icon]="['fas','circle-question']" [title]="(booking.totalDue - booking.totalPaid | currency:'GBP') + ' Due'" />
                                }
                                @else {
                                    <fa-icon class="text-red-500" [icon]="['fas','circle-xmark']" />
                                }
                            }
                            @if (booking.paypalPaymentId){
                                <fa-icon class="text-blue-500" [icon]="['fab','paypal']" [title]="'Paypal ID: ' + booking.paypalPaymentId"/>
                            }
                        </td>
                        <td>{{ booking.bookingPaid | date:'dd MMM yyyy HH:mm' }}</td>
                    </tr>
                }
            </tbody>
        </table>
    }
</app-admin-boilerplate>